import React, {useState} from 'react'
import Typography from '@material-ui/core/Typography';
import Tr from 'translations/Translations';
import GridBlock from 'components/GridBlock';
import {makeStyles} from "@material-ui/core";
import TextInput from "../../TextInput";
import Loading from "../../Loading";
import InputLimits from "../../../constants/InputLimits";
import UploadFile from "../../UploadFile";
import Box from "@material-ui/core/Box";
import MultiButton, {createButton} from "../../popup/components/MultiButton";
import AddContactor from "../../popup/addContactor/AddContactor";
import getObjectValue from "../../../libs/getObjectValue";
import InviteContactor from "../../popup/inviteContactor/InviteContactor";
import Chip from "../../Chip";
import ContractorService from "../../../services/ContractorService";

const useStyle = makeStyles(theme => ({
    margin: {
        marginBottom: theme.spacing(2)
    },
    inlineBlock: {
        display: 'inline-block',
        marginRight: theme.spacing(2)
    },
    loading: {
        width: '98%'
    },
    buttonRow: {
        textAlign: "end"
    },
    uploadFile: {
        marginBottom: 20
    },
    nameError: {
        fontSize: '0.75rem'
    }
}));

const limits = InputLimits.procedure.correspondence;

function AddThreadAsSupplierForm(
    {
        demandId,
        working,
        error,
        formikProps,

    }) {

    const classes = useStyle();

    const [addPopup, setAddPopup] = useState(false);
    const [invitePopup, setInvitePopup] = useState(false);

    const getFormButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('add_contractor'), () => setAddPopup(true), undefined, working));
        buttons.push(createButton(Tr('suggest_contractor'), () => setInvitePopup(true), undefined, working));
        return buttons;
    }

    const getInviteDefaultValues = () => ({
            name: getObjectValue('name', formikProps.values, ''),
            email: getObjectValue('email', formikProps.values, ''),
            vatin: {
                number: getObjectValue('vatin.number', formikProps.values, ''),
                prefix: getObjectValue('vatin.prefix', formikProps.values, 'PL'),
            }
        }
    )


    const handleClearContractor = () => {

        const values = {
            ...formikProps.values,
            contractorDepartmentId: 0,
            suggestContractor: false,
            contractorName: null,
            name: '',
            email: '',
            vatin: {
                number: '',
                prefix: "PL"
            }
        };
        formikProps.setValues(values);
    }

    const handleChipClick = () => {
        if (getObjectValue('suggestContractor', formikProps.values, false)) {
            setInvitePopup(true);
        } else {
            setAddPopup(true);
        }

    }
    const handleAddContractors = (data) => {

        if (data && data.platformAdded.length > 0) {
            ContractorService.getContractorDetails(demandId, data.platformAdded[0]).then((resp) => {
                handleClearContractor();
                formikProps.setFieldValue("contractorDepartmentId", data.platformAdded[0]);
                formikProps.setFieldValue("contractorName", resp.name);
            }).finally(() => setAddPopup(false));
        } else {
            setAddPopup(false);
        }
    }

    const handleInvite = (data) => {
        const values = {
            ...formikProps.values,
            suggestContractor: true,
            contractorDepartmentId: 0,
            contractorName:data.name,
            ...data
        };
        formikProps.setValues(values);
        setInvitePopup(false);
    }

    const contractorName = getObjectValue('contractorName', formikProps.values, false);
    const contractorNameError = getObjectValue('contractorName', formikProps.errors, '');

    return (<GridBlock column>
        {working && <Loading className={classes.loading}/>}

        <MultiButton className={classes.margin} buttons={getFormButtons()} justify='space-evenly'/>

        <div>
            <Typography color={contractorNameError ? 'error' : undefined} className={classes.inlineBlock}>{Tr('contractor')}*:</Typography>
            {!!contractorName && <Chip value={contractorName} onDelete={handleClearContractor} onClick={handleChipClick}/>}
            {!!contractorNameError && <Typography color='error' className={classes.nameError}>{contractorNameError}</Typography>}
        </div>

        {error && <Typography color='error'>{error}</Typography>}

        <TextInput
            id='subject'
            formikProps={formikProps}
            label={Tr('subject')}
            disabled={working}
            limit={limits.SUBJECT}
            required
        />

        <TextInput
            id='contents'
            formikProps={formikProps}
            label={Tr('contents')}
            disabled={working}
            multiline
            required
        />

        <Box component="div" className={classes.uploadFile}>
            <UploadFile
                id='attachments'
                formikProps={formikProps}
                label={Tr("attachment")}
                disabled={working}
            />
        </Box>

        {addPopup && <AddContactor
            demandId={demandId}
            onClose={() => setAddPopup(false)}
            addContractorsTab={handleAddContractors}
        />}

        {invitePopup && <InviteContactor
            demandId={demandId}
            open={true}
            onClose={() => setInvitePopup(false)}
            handleInvite={handleInvite}
            defaultValues={getInviteDefaultValues()}
        />}

    </GridBlock>)
}

export default AddThreadAsSupplierForm;